export const Contacts_data = {
  /// Contact details
  linkedinUrl: "https://linkedin.com/in/arvind-choudhary-0b0a82171/",
  mediumUrl: "https://arvind-choudhary.medium.com/",
  emailAdd: "arvindchoudhary142@yahoo.in",
  githubUsername: "Arvind142",
};
